/**
 * Ortsangaben als Pfad.
 *
 * Eine Adresse ist keine Zeile mit vier Spalten, sondern eine Kette von
 * Ebenen: "Haimschlag 30" liegt in "Haimschlag", das in "Echsenbach", das
 * in "Niederoesterreich". Getippt wird die Kette mit Komma, gespeichert
 * wird sie als Kette von Zeilen (`orte.teilVonId`).
 *
 * Der Gewinn ist die Anzeige: beim Geburtsort steht nur die unterste Ebene
 * ("Haimschlag 30"), nicht die ganze Anschrift. Den vollen Pfad rechnet man
 * aus, wo man ihn braucht - im Export, in der Ortsuebersicht, beim
 * Geokodieren. Die Postleitzahl steht einmal bei der Ortschaft und gilt
 * fuer alles darunter, statt bei jedem Haus noch einmal.
 */
/** Mehr Ebenen als das hat keine Adresse - der Rest ist ein Tippfehler. */
export const MAX_ORTSEBENEN = 6;
/** Laenge einer einzelnen Ebene, passend zur Spalte `orte.name`. */
export const MAX_ORTSNAME = 160;
/**
 * Laenge des ganzen getippten Pfades. Nicht zu verwechseln mit
 * `MAX_ORTSNAME`: 160 Zeichen sind die Grenze EINER Ebene. Wer das
 * Eingabefeld auf 160 begrenzt, macht eine Person mit langem Ortspfad
 * unspeicherbar - "Sankt Leonhard am Hornerwald 12, Sankt Leonhard am
 * Hornerwald, Bezirk Krems-Land, Niederoesterreich, Oesterreich" ist
 * laenger, und die Maske schickt beim Speichern zurueck, was sie anzeigt.
 */
export const MAX_ORTSPFAD = MAX_ORTSEBENEN * (MAX_ORTSNAME + 2);
/**
 * "Haimschlag 30, Echsenbach , Niederoesterreich" ->
 * ["Haimschlag 30", "Echsenbach", "Niederoesterreich"]
 *
 * Die unterste Ebene steht vorne, so wie man es schreibt und wie es auch
 * GEDCOM in `PLAC` haelt. Leere Glieder ("Krems,, Niederoesterreich")
 * fallen weg, doppelte Leerzeichen werden eingedampft.
 */
export function pfadZerlegen(eingabe) {
    return (eingabe ?? "")
        .split(",")
        .map((t) => t.trim().replace(/\s+/g, " ").slice(0, MAX_ORTSNAME))
        .filter((t) => t.length > 0)
        .slice(0, MAX_ORTSEBENEN);
}
/**
 * Postleitzahl (und ein vorangestelltes Laenderkuerzel) von einer Ebene
 * abtrennen: "3903 Echsenbach" -> { plz: "3903", name: "Echsenbach" },
 * "A-3903 Echsenbach" -> zusaetzlich { land: "A" }.
 *
 * Ohne das entstehen Dubletten, die niemand auseinanderhalten kann: wer
 * "Haimschlag 30, Echsenbach, NOe" eingetragen hat und spaeter
 * "Haimschlag 30, 3903 Echsenbach, NOe" tippt, bekommt sonst eine zweite
 * Kette, weil "3903 Echsenbach" ein anderer Name ist als "Echsenbach" -
 * und in der Vorschlagsliste stuende zweimal "Haimschlag 30", ohne
 * erkennbaren Unterschied.
 *
 * Die Postleitzahl ist keine Namensbestandteil, sondern eine eigene Spalte.
 * Vier- bis fuenfstellig am Anfang, gefolgt von einem Leerzeichen und dem
 * eigentlichen Namen - "3903 Echsenbach" ja, "3903" allein nein (das waere
 * dann eben der Name), "Wien 3" auch nein (die Ziffern stehen hinten).
 */
export function plzAbtrennen(segment) {
    const roh = segment.trim();
    const treffer = roh.match(/^(?:([A-Za-z]{1,3})\s*-\s*)?(\d{4,5})\s+(.+)$/);
    if (!treffer)
        return { land: null, plz: null, name: roh };
    return {
        land: treffer[1] ? treffer[1].toUpperCase() : null,
        plz: treffer[2],
        name: treffer[3].trim(),
    };
}
/** Umkehrung: aus den Ebenen wieder eine Zeile machen. */
export function pfadText(namen) {
    return namen.filter((n) => n && n.trim()).join(", ");
}
//# sourceMappingURL=ort.js.map